import { useState } from "react";
import { X, Ruler } from "lucide-react";
import { getSizeGuide } from "@/lib/sizeGuide";

const SizeGuideModal = ({ category }) => {
  const [open, setOpen] = useState(false);
  const guide = getSizeGuide(category);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-[10px] tracking-widest uppercase text-zinc-400 hover:text-white inline-flex items-center gap-1.5 underline-offset-4 hover:underline"
        data-testid="size-guide-trigger"
      >
        <Ruler size={12} /> Size Guide
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center px-4"
          onClick={() => setOpen(false)}
          data-testid="size-guide-modal"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-zinc-950 border border-zinc-800 w-full max-w-2xl p-6 max-h-[90vh] overflow-y-auto"
          >
            <div className="flex justify-between items-start pb-4 border-b border-zinc-800 mb-4">
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                  Size Guide · {guide.title}
                </div>
                <h2 className="font-heading text-3xl font-bold uppercase tracking-tight mt-1">
                  Find Your Fit
                </h2>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Close"
                data-testid="size-guide-close"
                className="text-zinc-400 hover:text-white"
              >
                <X size={18} />
              </button>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="size-guide-table">
                <thead className="bg-zinc-900 text-[10px] tracking-widest uppercase text-zinc-400">
                  <tr>
                    {guide.headers.map((h) => (
                      <th key={h} className="text-left px-4 py-3">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {guide.rows.map((row, i) => (
                    <tr key={i} className="border-b border-zinc-900">
                      {row.map((cell, j) => (
                        <td
                          key={j}
                          className={`px-4 py-3 ${
                            j === 0
                              ? "font-bold uppercase tracking-wider"
                              : "text-zinc-300"
                          }`}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="text-xs text-zinc-500 leading-relaxed mt-4">
              {guide.note}
            </p>

            <div className="border-t border-zinc-900 mt-6 pt-4 text-[10px] tracking-widest uppercase text-zinc-600">
              How to measure — wrap a soft tape parallel to the floor at the
              fullest part of your chest, narrowest part of your waist, and
              fullest part of your hips. Keep tape snug, not tight.
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SizeGuideModal;
